import { Co6TransactionTypes } from '@interfaces';
import { FlowTypes, IRATypes, IReceiptDTO, ISelectedClientAccountsState } from '@interfaces/models';
import { TriageState } from '@interfaces/state';
import {
  getIsExecutor,
  getIsInheritanceFlow,
  getIsIRAAccount,
} from '@store/reducers/triage/triage.reducer';

export function checkForFlowTypes(
  flowType: FlowTypes,
): Co6TransactionTypes.gifting | Co6TransactionTypes.inheritance | Co6TransactionTypes.minor {
  switch (flowType) {
    case FlowTypes.GIFTING:
      return Co6TransactionTypes.gifting;
    case FlowTypes.INHERITANCE:
      return Co6TransactionTypes.inheritance;
    case FlowTypes.MINOR:
      return Co6TransactionTypes.minor;
    default:
      return;
  }
}

export function createReceiptDTO(
  triageState: TriageState,
  selectedClientAccountsState: ISelectedClientAccountsState,
  receiptDTO: IReceiptDTO | any,
): IReceiptDTO | any {
  const iraType = selectedClientAccountsState.transferTo.iraType;
  const isNonEstateIRAInheritance =
    getIsInheritanceFlow(triageState) &&
    getIsIRAAccount(triageState) &&
    !getIsExecutor(triageState);
  const isInheritedIRAAccountType =
    iraType === IRATypes.INHERITED_OTHER || iraType === IRATypes.INHERITED_ROTH;

  if (isNonEstateIRAInheritance && isInheritedIRAAccountType) {
    const comment = 'Review of BENEF line required to match original decedent';
    return {
      ...receiptDTO,
      to: {
        ...receiptDTO.to,
        rows: receiptDTO.to.rows.map((row) =>
          row.evidenceID === 'toAccountNumber'
            ? { ...row, values: [...row.values, comment] }
            : { ...row },
        ),
      },
    };
  }

  return receiptDTO;
}
